// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__8S2D3"};